var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.9987C1.66663 5.05079 1.66663 3.57684 2.54396 2.59278C2.68428 2.43539 2.83894 2.28983 3.00617 2.15776C4.05174 1.33203 5.61781 1.33203 8.74996 1.33203H11.25C14.3821 1.33203 15.9482 1.33203 16.9937 2.15776C17.161 2.28983 17.3156 2.43539 17.456 2.59278C18.3333 3.57684 18.3333 5.05079 18.3333 7.9987C18.3333 10.9466 18.3333 12.4206 17.456 13.4046C17.3156 13.562 17.161 13.7076 16.9937 13.8396C15.9482 14.6654 14.3821 14.6654 11.25 14.6654H8.74996C5.61781 14.6654 4.05174 14.6654 3.00617 13.8396C2.83894 13.7076 2.68428 13.562 2.54396 13.4046C1.66663 12.4206 1.66663 10.9466 1.66663 7.9987Z",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 11.332H9.58325",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 11.332L14.9999 11.332",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 5.5H18.3333",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card_icon.5e8563d4e02eff9c49644b6d4d05f889.svg";
export { ForwardRef as ReactComponent };